var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',[_c('p',[_vm._v(" 当番組は閉鎖致しました。"),_c('br'),_vm._v(" 大変長らくご愛顧頂き誠にありがとうございます。"),_c('br'),_vm._v(" お問い合わせは下記のメールアドレスにお送り下さい。 ")]),_c('p',[_vm._v("運営事務局：info@weebb.jp")])])
}]

export { render, staticRenderFns }